var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.588 7.254c.491.383.552 1.059.135 1.51l-7.252 7.857c-.206.224-.503.36-.821.377a1.23 1.23 0 0 1-.864-.285l-4.414-3.776a1.01 1.01 0 0 1-.06-1.514 1.24 1.24 0 0 1 1.65-.054l3.52 3.01 6.461-7c.417-.452 1.153-.507 1.645-.125",
  clipRule: "evenodd"
})));
export default SvgCheckmark;